import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useLocation, Link, useParams } from 'react-router-dom';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
// import useFullPageLoader from '../../../commons/isn/useFullPageLoader';
import { getCategoriesBlog } from '../../blogs.api';
import { getPathLanguage } from '../../../../utils/params';
import { getQueryString } from '../../../../utils/params';

const Header = props => {
  const location = useLocation();
  const pathLanguage = getPathLanguage(location);
  // const [loader, showLoader, hideLoader] = useFullPageLoader();
  const { language } = useParams();
  const [categoryList, setCategoryList] = useState();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    props.showLoader();

    getCategoriesBlog(getQueryString({ language })).then(
      res => {
        if (res) {
          setCategoryList(res.data);
          props.hideLoader();
        }
      },
      rej => {
        console.log(rej);
        props.hideLoader();
      },
    );
    //eslint-disable-next-line
  }, [language]);

  return (
    <>
      <div className="row">
        {categoryList
          ? categoryList.map((item, index) => (
              <div className="col-12 col-md" key={index}>
                <Link
                  to={`${pathLanguage}/blogs/${item.titleEn.toLowerCase().replaceAll(' ', '-')}${
                    Number(item.id) !== 1 ? '/' + item.id : ''
                  }?pageIndex=1`}
                  onClick={() => {
                    localStorage.setItem('pageNumberBlog', 1);
                  }}
                  className={`blog-category w-100 ${
                    location.pathname.includes(item.titleEn.toLowerCase().replaceAll(' ', '-')) ? 'actived' : ''
                  }`}
                >
                  <img src={`${process.env.REACT_APP_ISN_IMAGE_URL}${item.imageUrl}`} alt="" className="img-category" />
                  {/* <LazyLoadImage src={item.image} alt="" className="img-category" effect="blur" /> */}
                  <span className="category-name">{item.title}</span>
                </Link>
              </div>
            ))
          : ''}
      </div>
      {/* {loader} */}
    </>
  );
};

const mapStateToProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Header);
